import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FOR_INVESTORS_SECTIONS,
  FOR_INVESTORS_SUB_SECTIONS,
} from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { ProductionPlansAndSpecifics } from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/ProductionPlansAndSpecifics';
import {
  prefix,
  PRODUCTION_NAMES,
} from 'components/BusinessToolForm/Sections/BusinessOperations/ProductionSection/utils/form';

import { concatWithDot } from 'helpers/string';

export const Production: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_BUSINESS_OPERATIONS.PRODUCTION
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.production.title')}
          section={FOR_INVESTORS_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.7.1 */}
      <ProductionPlansAndSpecifics disabled={!canAccess} />
      {/* 6.7.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.production.specifics')}
        aiFieldName={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
          name={concatWithDot(prefix, PRODUCTION_NAMES.SPECIFICS)}
          minRows={3}
          disabled={!canAccess}
        />
      </FormSectionCard>
    </>
  );
};
